<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- <div class="search-area" style="overflow: hidden">
      <template v-for="(side, index) in appsideList">
        <el-radio
          v-model="appSideGuid"
          :key="index"
          :label="side.guid"
          style="padding: 30px 25px 45px 25px"
          class="fl"
          border
          >{{ side.appSideName }}</el-radio
        >
      </template>
    </div> -->
    <div class="search-area">
      <p class="t-left font-S14 fontC-4fa1a4 mb20" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p>
      <TabList :tabList="appsideList" :tabIndex="tabIndex" @tabChange="tabChange"></TabList>
      <el-row :gutter="24" class="mt20">
        <el-col :span="6"
          ><div class="search-area-div">角色名称</div>
            <el-input v-model="page.roleName"  class="ipt-sty"/>
           </el-col>
        <el-col :span="6">
          <div class="search-area-div">状态</div>
          <el-select size="mini" v-model="page.bizState" clearable placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in bizStateOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini"  @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="height:100%">
      <div class="button-area" >
        <!-- <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">新增角色</el-button> -->
        <el-button icon="el-icon-plus" size="mini" type="info" @click="add0()">新增角色</el-button>
        <el-button size="mini"  @click="getDeleteData(1, '')">批量删除</el-button>
        <!-- <el-button plain size="medium">历史数据</el-button> -->
      </div>
      <el-table
        :data="tableData"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
        border
        stripe
        tooltip-effect="light"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column type="selection" width="40" header-align="center" align="center" :selectable="selectable"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="roleName" width="130" show-overflow-tooltip label="角色名称" header-align="center" align="left"></el-table-column>
        <el-table-column
          prop="orderNum"
          label="顺序"
          header-align="center"
          width="70"
          align="right"
        ></el-table-column>
        <el-table-column prop="bizState" label="状态" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.bizState | getBizState }}</template>
        </el-table-column>
        <el-table-column prop="createUserNameNew" width="100" label="创建人" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserNameNew || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" width="130" label="创建时间" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserNameNew" width="100" label="修改人" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserNameNew || '-' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" width="130" label="上次更新时间" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="dutyUserNameNew" width="100" label="负责人" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.dutyUserNameNew || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="240">
          <template slot-scope="scope">
            <!-- <a class="txt-color" v-if="scope.row.isCanOperation == 'Y'" @click="add(2, scope.row)">编辑 | </a> -->
            <a class="txt-color" v-if="scope.row.isCanOperation == 'Y'" @click="add0(scope.row)">编辑 | </a>
            <a class="txt-color-grey" v-if="scope.row.isCanOperation !== 'Y'" @click="clickTip(1)">编辑 | </a>
            <a class="txt-color" v-if="appSideName == '运营端'" @click="addReportRole(scope.row)">报表权限设置 | </a>
            <!-- <a class="txt-color" @click="add1(scope.row)">数据权限 | </a> -->
            <a class="txt-color" v-if="scope.row.isCanOperation == 'Y'" @click="getDeleteData(2, scope.row.guid)">删除 | </a>
            <a class="txt-color-grey" v-if="scope.row.isCanOperation !== 'Y'" @click="clickTip(1)">删除 | </a>
            <!-- <a class="txt-color"  @click="popupBox(1,scope.row.guid,scope.row.dutyUserId)">变更负责人 | </a> -->
            <a class="txt-color" v-if="scope.row.isCanOperation == 'Y'" @click="chooseDepartmentPerson(scope.row)">变更负责人</a>
            <a class="txt-color-grey" v-if="scope.row.isCanOperation !== 'Y'" @click="clickTip(1)">变更负责人 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 50,100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog
      :title="textTitle"
      :visible.sync="dialogFormVisible"
      width="650px"
      @close="clearDialog"
      style="margin-bottom: 0"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :label-position="right" class="demo-ruleForm">
        <el-form-item label="角色名称:" prop="roleName">
          <el-input v-model="ruleForm.roleName" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序:" prop="orderNum">
          <el-input v-model="ruleForm.orderNum" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.bizState" label="S">停用</el-radio>
        </el-form-item>
        <el-form-item label="应用产品:" class="t-left" style="margin-bottom: 0">
          <div class="borderR6 border-4f">
            <template>
              <el-checkbox-group v-model="productGuidList">
                <el-checkbox
                  class="mb16"
                  @change="changePro(product)"
                  v-for="product in productList"
                  :key="product.guid"
                  :label="product.guid"
                  border
                  size="small"
                >
                  <span :class="activeProduct == product.guid ? 'check-txt fontC-4fa1a4' : 'check-txt'">{{
                    product.productName
                  }}</span>
                  <!-- <span :class="activeProduct==product.guid?'fontC-4fa1a4':''" @click.prevent="changePro(product)">{{product.productName}}</span> -->
                  <!-- {{ product.productName }} -->
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <el-tree
              v-if="isTreeShow"
              :data="currentProduct.menus"
              show-checkbox
              node-key="guid"
              ref="tree"
              :expand-on-click-node="false"
              :props="defaultProps"
              @check-change="handleNodeCilck"
              :check-strictly="checkStrictly"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  >{{ data.menuName }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span
                >
              </span>
              <!-- @check-change="handleNodeCilck" -->
              <!--  :default-checked-keys="ids" -->
              <!-- :check-strictly="isCheck" -->
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="clearDialog()">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '新增角色'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="数据权限" :visible.sync="dialogFormVisible1" width="550px">
      <el-form
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm1"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="角色名称:" prop="number">
          <el-input v-model="ruleForm1.roleName" autocomplete="off" class="w100f" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="权限范围:" prop="pwd">
          <el-select v-model="ruleForm1.scopeOfAuthority" class="w100f" placeholder="请选择">
            <el-option
              v-for="item in datapermissionsList"
              :key="item.dataPermissionType"
              :label="item.dataPermissionName"
              :value="item.dataPermissionType"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色权限:" class="t-left" v-if="ruleForm1.scopeOfAuthority == 'C'">
          <div class="borderR6 p10 border-4f">
            <el-tree
              :data="organisationDetail"
              show-checkbox
              node-key="guid"
              :default-checked-keys="idss"
              ref="tree1"
              :props="defaultPropsOrganisation"
              @check-change="handleNodeCilck1"
            >
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible1 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm1('ruleForm1')">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>

    <!-- 报表权限设置 -->
    <el-dialog title="报表权限设置" :visible.sync="reportVisible" width="950px">
      <el-form
        :model="ruleForm2"
        :rules="rules"
        ref="ruleForm2"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="报表导航名称:" prop="pwd">
          <el-select v-model="ruleForm2.navigationPageGuid" class="w100f" placeholder="请选择" @change="getNavigationRoleReportRel(ruleForm2.navigationPageGuid)">
            <el-option
              v-for="item in reportMenuData"
              :key="item.guid"
              :label="item.navigationPageName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表权限:" class="t-left">
          <div class="borderR6 p10 border-4f">
            <el-tree
              :data="avigationPageList"
               v-if="avigationPageList != null && avigationPageList.length > 0"
              show-checkbox
              node-key="id"
              :default-checked-keys="menuid"
              ref="tree2"
              :props="defaultMeun"
              @check-change="handleNodeCilck2"
            >
            </el-tree>
            <span v-else>暂无数据!</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="reportVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="deleteReport()">确定</el-button>
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
    <!-- 人员表格 -->
    <ChoosePerson
      :showChoosePerson.sync="showChoosePerson"
      :areaData="areaData"
      :list="belongStaffList"
      @getPerson="getPerson"
    >
    </ChoosePerson>
    <!-- 人员表格 -->
    <!-- 选择部门人员 start -->
    <ChooseUser ref="chooseDepartment"  @onSelect="getPerson"></ChooseUser>
      <!-- 选择部门人员 end -->
  </div>
</template>

<script>
import { route1 } from '../../api/apiRoute';
import TabList from '@/components/tab/tabList.vue'
import ChoosePerson from '../roleManagementNew/components/ChoosePerson.vue';
import ChooseUser from '../roleManagementNew/components/ChooseUser.vue';
import mixins from '../roleManagementNew/components/mixins/detailMixins.js';
import { JSEncrypt } from 'jsencrypt';
export default {
  components:{
    TabList,
    ChoosePerson,
    ChooseUser
  },
  mixins: [mixins],
  data() {
    return {
      areaData:[],
      showChoosePerson: false, // 人员选择
      belongStaffList: [], // 指派人员列表
      changebelongStaffList: [], // 修改后的指派人员
      tableHeight: window.innerHeight - 350,
      contentMainHeight: window.innerHeight - 295,
      fullscreenLoading:false,
      isCheck: false,
      input: '',
      textTitle: '',
      appSideGuid: '',
      platformGuid: '',
      productGuid: '',
      productGuidList: [],
      right: '',
      bizStateOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'Y',
          label: '有效'
        }, {
          value: 'S',
          label: '停用'
        }
      ],
      dialogVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      reportVisible:false,
      formLabelWidth: '120px',
      avigationPageList:[],
      reportPageGuids:[],
      ids: [],
      idss: [],
      menuid:[],
      defaultProps: {
        id: 'guid',
        label: 'menuName',
        children: 'children',
      },
      defaultPropsOrganisation: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
      defaultMeun: {
        id: 'id',
        label: 'label',
        children: 'children',
      },
      roleGuid:'',
      tree: '',
      tree1: '',
      ruleForm: {
        guid: '',
        platformGuid: '',
        appSideGuid: '',
        roleName: '',
        orderNum: '',
        bizState: 'N',
        menuGuids: '',
        tenantGuid: '',
      },
      ruleForm1: {
        roleGuid: '',
        dataPermissionGuids: '',
        customDataPermissionGuid: '',
        customData: '',
        scopeOfAuthority: '',
      },
      ruleForm2: {
        roleGuid: '',
        navigationPageGuid:'',
        menuGuidList:[]
      },
      appsideList: [],
      productList: [],
      allMenuList: [],
      menuGuidList: [],
      organisationGuidList: '',
      roleDetailData: [],
      organisationDetail: [],
      datapermissionsList: [],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        appSideGuid: '',
        roleName: '',
        bizState: 'Y',
        tenantGuid: '',
      },
      appSideName:'',
      loading: false,
      tableData: [],
      superiorOrganization: [],
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 15 个字符', trigger: 'blur' },
        ],
      },
      multipleSelection: [],
      activeProduct: '',
      currentProduct: {},
      checkStrictly: false,
      isTreeShow: true,
      reportMenuData:[],
      tabIndex:0,
      // data:JSON.parse(JSON.stringify(allMenuList))
      reportToken:'',
      curUserPltTenantGuid:'',
    };
  },
  created() {
    // 列表
    this.getAppsideData();
    this.getReportToken()
    if(this.$route.query.guid){//编辑/复制

    }
  },
  watch: {
    activeProduct(val) {
      this.currentProduct = this.productList.find((k) => k.guid === val) || {};
      this.refreshTree();
    },
    appSideGuid() {
      let self = this;
      self.appsideList.forEach(function (item) {
        console.log(self.appSideGuid,item);
        if (self.appSideGuid == item.guid) {
          self.platformGuid = item.platformGuid;
          self.appSideName = item.appSideName;
        }
      });
      self.page.pageIndex = 1;
      self.getData(false);
    },
  },
  methods: {
    // 负责人回显
    // showSalesman(val) {
    //   console.log(val);
    //   let query = {
    //     customerGuids: this.customerGuids,
    //     pageIndex: this.page.pageIndex,
    //     // 要把列表所有数据获取到
    //     pageSize: 10000,
    //   };

    //   this.api.postJson(`/${serverConfig.msCustomerService}/customer/get-belong-staff`, query).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       this.belongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
    //       this.changebelongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
    //     } else {
    //       this.$message.error(res.data.data.msg);
    //     }
    //   });
    // },
    // 变更负责人，获取勾选的人员
    getPerson(res) {
      console.log(res,1,this.roleGuid);
      this.changebelongStaffList = res;
      this.updateDuty(res.userGuid,this.roleGuid)
    },
    // 选择人员弹框
    chooseDepartmentPerson(row) {
        if(this.isDisabled)return;
        // index为编辑时的下标
        this.roleGuid=row.guid
        let tenantGuid=this.$store.getters.getTenantGuid;
        this.$refs.chooseDepartment.open([row.dutyUserIdNew],tenantGuid,'','1');
        // this.$refs.chooseDepartment.open(['25a3384a7b634f868313c325f3bfbdfc'],tenantGuid);
        // if(flg===1){//新增
        //   this.$refs.chooseDepartment.open([]);
        // }else{
        //   // let departmentList = this.departmentList;
        //   let departmentList = this.departmentList[index];
        //   let personList = [];
        //   departmentList.forEach(i => {
        //     personList.push(i.guid);
        //   });
        //   let tenantGuid=departmentList[0].tenantGuid
        //   this.$refs.chooseDepartment.open(personList,tenantGuid,index);
        // }

      },
    // 变更负责人
    updateDuty(guid,roleGuid){
      let self=this
      let query={
        roleGuid:roleGuid,
        dutyUserId:guid,
      }
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/update-duty`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          this.getData(true)
          // self.appsideList = res.data.data.records || [];
          // if(self.appsideList && self.appsideList.length > 0){
          //   self.appSideGuid = self.appsideList[0].guid;
          //   self.appSideName = self.appsideList[0].appSideName;
          //   self.platformGuid = self.appsideList[0].platformGuid;
          //   self.appsideList.forEach(i=>{
          //     i.tabName = i.appSideName;
          //   })
          // }
          // self.getAllProduct();
          // self.page.totalPage = res.data.data.totalPages;
          // self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    clickTip(type){
      this.$message.error('非自己负责的角色不可操作，如需修改请联系管理员');
    },
    //清空弹窗内容
    clearDialog() {
      this.productGuidList = [];
      this.allMenuList = [];
      this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false;
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>
            {data.menuName} <span v-if="data.remark">（{data.remark}）</span>
          </span>
        </span>
      );
    },
    changePro(val) {
      this.activeProduct = val.guid;
    },
    selectable (row, index){
      // 可删除 才能被选中
      if(row.isCanOperation == 'Y' ){
        return true;
      }
    },

    handleNodeCilck(node, checked, data) {
      // let self = this;
      // this.currentProduct.checkedKeys = this.$refs.tree.getCheckedKeys();
      this.currentProduct.checkedKeys = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())

      // self.checkStrictly = false
      // if(checked == false){
      //   self.currentProduct.checkedKeys.forEach((i,index)=>{
      //     if(node.guid == i){
      //       this.currentProduct.checkedKeys.splice(index,1)
      //     }
      //   })
      // }
      // this.$refs.tree.getHalfCheckedKeys() 选中子节点也选中父节点
      // let tree = this.$refs.tree;
      // let ss = tree.getCheckedKeys().concat(self.menuGuidList).concat(tree.getHalfCheckedKeys());
      // self.menuGuidList = [...new Set(ss)];
    },
    // 点击tab
    tabChange(item,index){
      this.appSideGuid = item.guid;
      this.getAllProduct();
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        appSideGuid: '',
        roleName: '',
        bizState: 'Y',
        tenantGuid: '',
      };
      self.getData(true);
    },
    getAppsideData(flg) {
      let self = this;
      self.loading = true;
      let promise = {
        guid: '',
        pageIndex: 1,
        appSideName: '',
        pageSize: 100,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
        startTime: '',
        endTime: '',
      };
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.appsideList = res.data.data.records || [];
          if(self.appsideList && self.appsideList.length > 0){
            self.appSideGuid = self.appsideList[0].guid;
            self.appSideName = self.appsideList[0].appSideName;
            self.platformGuid = self.appsideList[0].platformGuid;
            self.appsideList.forEach(i=>{
              i.tabName = i.appSideName;
            })
          }
          self.getAllProduct();
          // self.page.totalPage = res.data.data.totalPages;
          // self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAllProduct() {
      let self = this;
      this.productList = [];
      this.activeProduct = '';
      self.api
        .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, {
          platformGuid: self.platformGuid,
          appSideGuid:self.appSideGuid,
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data && res.data.data.records){
              self.productList = res.data.data.records ;
              if(self.productList && self.productList.length > 0){
                self.productGuid = self.productList[0].guid;
              }
              if(self.textTitle == '新增角色'){
                self.getAllMenu();
              }
            }

          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    refreshTree() {
      let checkedKeys = this.currentProduct.checkedKeys ? JSON.parse(JSON.stringify(this.currentProduct.checkedKeys)) :[]
      this.isTreeShow = false;
      console.log('checkedKeys',checkedKeys);

      this.$nextTick(() => {
        // 重新渲染菜单树节点
        this.isTreeShow = true;
        this.$nextTick(() => {
          // //console.log(checkedKeys);
          // //console.log(this.currentProduct.menus,'currentProduct.menus');
          // this.$refs.tree && this.$refs.tree.setCheckedKeys(checkedKeys || []); // !这个钩子, 如果数组中包含父级id, 会默认勾选全部子集
          checkedKeys.forEach(item=>{
            this.$refs.tree && this.$refs.tree.setChecked(item,true,false);
          })
        });
      });
    },
    getAllMenu() {
      let self = this;
      self.fullscreenLoading = true;
      setTimeout(() => {

      }, 3000);
      const AllPromises = (this.productList || []).map((product) => {
        let promise = {
          guid: '',
          parentGuid: '',
          platformGuid: self.platformGuid,
          productGuid: [product.guid],

        };
        return new Promise((resolve) => {
          self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.allMenuList = res.data.data;
              product.menus = res.data.data;
              console.log('self.menuGuidList',self.menuGuidList);

              product.checkedKeys = self.menuGuidList.filter((k) => {
                const hasNodeByGuid = (guid, tree) => {
                  // 判断树中有guid
                  return tree.find((item) => {
                    return item.guid === guid || hasNodeByGuid(guid, item.children || []);
                  });
                };
                return hasNodeByGuid(k, product.menus);
              });
              // self.menuGuidList = self.ids;
              // self.allMenuList.forEach((item) => {
              //   item.menuName = item.remark ? item.menuName + '（' + item.remark + '）': '（'+item.menuName + '）'; //菜单名+标签
              //   if (item.children) {
              //     item.children.forEach((oneData) => {
              //       oneData.menuName = oneData.remark ? oneData.menuName + '-' + oneData.remark : oneData.menuName ; //菜单名+标签
              //     });
              //   }
              // });
              resolve(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
      });
      Promise.all(AllPromises).then((res) => {this.refreshTree();self.fullscreenLoading = false;})
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.appSideGuid = self.appSideGuid;
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.page.isAdmin = JSON.parse(localStorage.userInfo).isAdmin;
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/delete`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除角色成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    addReportRole(row){
      let self = this;
      self.menuid = [];
      self.avigationPageList = [];
      self.ruleForm2.navigationPageGuid = '';
      self.ruleForm2.roleGuid = row.guid;
      self.getReportMenuData();
      self.reportVisible = true;
    },
    //已选
    getNavigationRoleReportRel(){
      let self = this;
      self.menuid = [];
      let loginUrl = route1 + `/${serverConfig.msReportConfigService}`+'/navigation/get-navigation-role-report-rel';
      let item = {
        appSystemLabel:'FBT',
        pageIndex	:1,
        pageSize:-1,
        navigationPageGuid:self.ruleForm2.navigationPageGuid,
        roleGuid:self.ruleForm2.roleGuid
      }
      fetch(loginUrl, {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": self.reportToken,
                    "Cur-User-Plt-Tenant-Guid":self.curUserPltTenantGuid
                },
                body:JSON.stringify(item)
            }
      )
      .then(function (res) { return res.json(); }) .then(function (res) {
        let data = res.data.records;
        if(data != null && data.length > 0){
          data.forEach((i)=>{
            let item = {
              id:i.reportPageGuid,
              label:i.reportPageName
            }
            self.menuid.push(i.reportPageGuid);
          })
        }
        console.log('已选',self.menuid);
        self.getNavigationPage(self.ruleForm2.navigationPageGuid);
        // self.menuid = res.data.records;
      })
    },
    getReportMenuData(){
      let self = this;
      self.reportMenuData = [];
      let loginUrl = route1 + `/${serverConfig.msReportConfigService}`+'/navigation/get';
      let item = {
        appSystemLabel: "FBT",
        pageIndex:self.page.pageIndex,
        pageSize:-1
      }
      fetch(loginUrl, {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": self.reportToken,
                    "Cur-User-Plt-Tenant-Guid":self.curUserPltTenantGuid
                },
                body:JSON.stringify(item)
            }
      )
      .then(function (res) { return res.json(); }) .then(function (res) {
        self.reportMenuData = res.data.records;
      })
    },
    getReportToken(){
      let self = this;
      let loginInfo = {
        username: 'ExternalAccount',
        // pwd: 'd70413d70ad4af480fa4c6952ab8edb3',//正式
        pwd: '21232f297a57a5a743894a0e4a801fc3',//测试
        timestamp: new Date().getTime()
      }
      let loginUrl = route1 +`/${serverConfig.msReportConfigService}`+ '/user/login?'+`logonUser=`+loginInfo.username+`&pwd=`+loginInfo.pwd;
      let item = {
        appSystemLabel: "FBT",
        pageIndex:self.page.pageIndex,
        pageSize:-1
      }
      fetch(loginUrl, {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            "Authorization": self.$store.state.token,
        },
        body:JSON.stringify(item)
      }
      )
      .then(function (res) { return res.json(); }) .then(function (res) {
        console.log('登录成功',res);
        self.reportToken = res.data.token;
        self.curUserPltTenantGuid = res.data.curUserPltTenantGuid;

      })
      // this.api.postJson(loginUrl).then((res) => {
      //   if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //     console.log('登录成功');

      //   } else {
      //     this.$message.error(res.data.msg);
      //   }
      // });
    },
    getNavigationPage(guid){
      let self = this;
      self.reportPageGuids = [];
      self.avigationPageList = [];
      let loginUrl = route1 + `/${serverConfig.msReportConfigService}`+'/navigation/get-navigation-sort-report-by-report-attrib';
      let item = {
        navigationPageGuid:guid,
        sortType:2
      }
      fetch(loginUrl, {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": self.reportToken,
                    "Cur-User-Plt-Tenant-Guid":self.curUserPltTenantGuid
                },
                body:JSON.stringify(item)
            }
      )
      .then(function (res) { return res.json(); }) .then(function (res) {
        self.avigationPageList = res.data.navigationSortReportList;
        if(self.avigationPageList != null){
          self.avigationPageList.forEach((i)=>{
              i.id = i.navigationSortGuid;
              i.label = i.navigationSortName;
              i.children = [];
              if(i.reportPageList != null && i.reportPageList.length > 0){
                i.reportPageList.forEach((j)=>{
                  let item = {
                    id:j.guid,
                    label:j.pageName
                  }
                  i.children.push(item);
                })
              }
          })
        }
      })
    },
    deleteReport(){
      let self = this;
      let delReportList = [];
      console.log('新',self.reportPageGuids);
      console.log('老',self.menuid);

      self.menuid.forEach((m,index)=>{
      if(self.reportPageGuids.indexOf(m) == -1){
          delReportList.push(m);
        }
      })
      console.log('删除的',delReportList);
      self.fullscreenLoading = true;
      if(delReportList != null && delReportList.length > 0){
        let loginUrl = route1 + `/${serverConfig.msReportConfigService}`+'/navigation/remove-navigation-role-report-rel';
        let item = {
          appSystemLabel:'FBT',
          reportPageGuids:delReportList,
          roleGuid:self.ruleForm2.roleGuid
        }
        fetch(loginUrl, {
            method: "DELETE",
            headers: {
                "Content-type": "application/json",
                "Authorization": self.reportToken,
                "Cur-User-Plt-Tenant-Guid":self.curUserPltTenantGuid
            },
            body:JSON.stringify(item)
          }
        )
        .then(function (res) { return res.json(); }) .then(function (res) {
          self.fullscreenLoading = false;
          if (res.code == '00000') {
            self.$nextTick(() => {
              self.submitForm2();
            })
          } else {
            self.$message.error(res.data.msg);
          }
        })
      }else{
        self.submitForm2();
      }

    },
    submitForm2(){
      let self = this;
      if(self.reportPageGuids == null && self.reportPageGuids == ''){
        self.$message.error('请选择需要设置的菜单!');
        return
      }
      let addReportList = [];
      self.reportPageGuids.forEach((m,index)=>{
      if(self.menuid.indexOf(m) == -1){
          addReportList.push(m);
        }
      })
      if(addReportList != null && addReportList.length > 0){
        let userInfo = JSON.parse(localStorage.userInfo);
        let loginUrl = route1 + `/${serverConfig.msReportConfigService}`+'/navigation/add-navigation-role-report-rel';
        let item = {
          appSystemLabel:'FBT',
          createUserId:userInfo.userGuid,
          createUserName:userInfo.staffName,
          reportPageGuids:addReportList,
          roleGuid:self.ruleForm2.roleGuid
        }
        fetch(loginUrl, {
                  method: "POST",
                  headers: {
                      "Content-type": "application/json",
                      "Authorization": self.reportToken,
                      "Cur-User-Plt-Tenant-Guid":self.curUserPltTenantGuid
                  },
                  body:JSON.stringify(item)
              }
        )
        .then(function (res) { return res.json(); }) .then(function (res) {
          self.fullscreenLoading = false;
          if (res.code == '00000') {
            self.$message.success("报表菜单设置成功!");
            self.reportVisible = false;
            self.getData(false);
          }else{
            self.$message.error(res.msg);
          }
        })
      }else{
        self.fullscreenLoading = false;
        self.$message.success("报表菜单设置成功!");
        self.reportVisible = false;
        self.getData(false);
      }
    },
    add1(row) {
      let self = this;
      self.ruleForm1.roleGuid = row.guid;
      self.ruleForm1.roleName = row.roleName;
      self.getSuperiorOrganization();
      self.getOrganisationGuid();
      self.getDatapermissions();
      self.ruleForm1.scopeOfAuthority = 'F';
      self.dialogFormVisible1 = true;
    },
    //加载子节点
    AddChildren: function (item, elems) {
      for (let i = 0; i < elems.length; i++) {
        let elem = elems[i];
        if (elem.parentGuid == item.guid) {
          if (item) {
            item.children ? item.children.push(elem) : (item.children = [elem]);
          }
          this.AddChildren(elem, elems);
        }
      }
    },
    handleNodeCilck1(node, data) {
      let self = this;
      var rad = '';
      var ridsa = this.$refs.tree1.getCheckedKeys().join(','); // 获取当前的选中的数据[数组] -id, 把数组转换成字符串
      var ridsb = this.$refs.tree1.getCheckedNodes(); // 获取当前的选中的数据{对象}
      ridsb.forEach((ids) => {
        //获取选中的所有的父级id
        rad += ',' + ids.guid;
      });
      rad = rad.substr(1); // 删除字符串前面的','
      var rids = rad + ',' + ridsa;
      var arr = rids.split(','); //  把字符串转换成数组
      arr = [...new Set(arr)]; // 数组去重
      rids = arr.join(','); // 把数组转换成字符串
      self.organisationGuidList = rids;
    },
    handleNodeCilck2(node, data) {
      let self = this;
      self.reportPageGuids = [];
      var ridsb = this.$refs.tree2.getCheckedKeys(); // 获取当前的选中的数据{对象}
      // console.log(ridsb);
      if(ridsb != null && ridsb.length > 0){
        ridsb.forEach((i)=>{
          self.reportPageGuids.push(i);
        })
      }
      // console.log(self.reportPageGuids);

      let item  = [];
      self.avigationPageList.forEach((n)=>{
        item.push(n.id);
      })
      // console.log('111',item);
      self.reportPageGuids.forEach((m,index)=>{
      if(item.indexOf(m) != -1){
          self.reportPageGuids.splice(index,1);
        }
      })
      console.log(self.reportPageGuids);
    },
    getSuperiorOrganization() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?` + `tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationDetail = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getDatapermissions() {
      let self = this;
      let promise = {
        roleGuid: self.ruleForm1.roleGuid,
      };
      self.api
        .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/data-permission/data/get-datapermissions`, promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.datapermissionsList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getOrganisationGuid() {
      let self = this;
      self.idss = [];
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/data-permission/data/get-organisationguid-by-role?` +
            `roleGuid=` +
            self.ruleForm1.roleGuid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.superiorOrganization = res.data.data;
            self.idss = self.superiorOrganization;
            // self.menuGuidList = self.idss;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    submitForm1(formName) {
      let self = this;
      let dataPermissionGuids = [];
      self.datapermissionsList.forEach(function (j) {
        if (j.dataPermissionType == self.ruleForm1.scopeOfAuthority) {
          self.ruleForm1.customDataPermissionGuid = j.guid;
        }
      });
      if (self.ruleForm1.scopeOfAuthority == 'F') {
        self.customData = '';
        dataPermissionGuids = self.idss;
      } else {
        dataPermissionGuids = [];
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            roleGuid: self.ruleForm1.roleGuid,
            dataPermissionGuids: dataPermissionGuids,
            customDataPermissionGuid: self.ruleForm1.customDataPermissionGuid,
            customData: self.organisationGuidList,
          };
          self.api
            .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/add-data-permission`, promise)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible1 = false;
                self.organisationGuidList = '';
                self.idss = [];
                self.$message.success('新增数据权限成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    add(flg, row) {
      let self = this;
      self.getAllProduct();
      if (flg == 1) {
        self.productGuidList = [];
        self.textTitle = '新增角色';
        self.ruleForm.roleName = '';
        self.ruleForm.orderNum = '';
        self.ruleForm.bizState = 'Y';
        self.menuGuidList = [];
        self.ids = [];
        self.allMenuList = [];
        self.activeProduct = '';
      } else {
        self.textTitle = '编辑角色';
        // self.productGuidList = []
        self.ruleForm.guid = row.guid;
        self.appSideGuid = row.appSideGuid;
        self.platformGuid = row.platformGuid;
        self.ruleForm.roleName = row.roleName;
        self.ruleForm.orderNum = row.orderNum;
        self.ruleForm.bizState = row.bizState;
        self.menuGuidList = [];
        self.getDataDetail(row.guid);
      }
      self.dialogFormVisible = true;
      if (flg == 1) {
        //弹窗显示后才能获取到refs的树节点
        setTimeout(function () {
          self.$refs.tree.setCheckedKeys([]); //给树节点赋值
        }, 200);
      }
      // this.$router.push({
      //   path: '/addRoleConfig',
      //   query: {
      //     productGuid: localStorage.productGuid,
      //     guid:row?row.guid:'',
      //     appSideGuid:this.appSideGuid,
      //     platformGuid: this.platformGuid,
      //   },
      // });
    },
    add0(row){
       this.$router.push({
        path: '/addRoleConfig',
        query: {
          productGuid: localStorage.productGuid,
          guid:row?row.guid:'',
          tenantGuid:this.page.tenantGuid,
          appSideGuid:this.appSideGuid,
          platformGuid: this.platformGuid,
        },
      });
    },
    // !递归拿到菜单配置的所有id
    getMenuGuidList(tree) {
      tree.forEach(item=>{
        if (this.ids.indexOf(item) == -1) this.ids.push(item.guid);
        if (item.children){
          this.getMenuGuidList(item.children)
        }
      })
    },
    getDataDetail(guid) {
      let self = this;
      if (guid == null || guid == '') {
        return;
      }
      self.ids = [];
      // self.checkStrictly = true
      self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get-detail?guid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.activeProduct = res.data.data.productGuid ? res.data.data.productGuid[0] : '';
          self.productGuidList = res.data.data.productGuid ? res.data.data.productGuid : [];
          self.roleDetailData = res.data.data.children || [];
          self.roleDetailData.forEach((i)=>{
            if (i.children) {
              // i.children.forEach(function (j) {
              //   if (self.ids.indexOf(j.guid) == -1) {
              //     self.ids.push(j.guid);
              //   } else if (j.children) {
              //     j.children.forEach(m=>{
              //       if (self.ids.indexOf(m.guid) == -1) {
              //         self.ids.push(m.guid);
              //       }
              //     })
              //   }
              // });
              self.getMenuGuidList(i.children)
            } else {
              self.ids.push(i.guid);
            }
          });
          self.menuGuidList = self.ids;
          console.log(JSON.stringify(self.menuGuidList),'menuGuidList');
          self.isCheck = true; //重点：给数节点赋值之前 先设置为true
          self.$nextTick(() => {
            //因为我是根据数据id来判断选中所以使用setCheckedKeys，具体可以查看element官网api
            // self.$refs.tree.setCheckedKeys(self.menuGuidList); //给树节点赋值

            self.isCheck = false; //重点： 赋值完成后 设置为false
          });
          // setTimeout(()=>{

          // },2000)
          this.$nextTick(() => {
            self.getAllMenu();
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    submitForm(formName) {
      let self = this;
      console.log('object11111', this.productList);
      self.$refs[formName].validate((valid) => {
        if (valid) {
          const menuGuids = this.productList
            .reduce((total, next) => {
              const arr = (next.checkedKeys || [])
                .map((guid) => {
                  const node = this.getNodeByGuid(guid, next.menus) || {};
                  return node.parentGuid ? node.parentGuid + '-' + node.guid : node.guid;
                })
                .join('-')
                .split('-');
              return [...total, ...arr];
            }, [])
            .filter((k) => k);
          let promise = {
            platformGuid: self.platformGuid,
            appSideGuid: self.appSideGuid,
            roleName: self.ruleForm.roleName,
            orderNum: self.ruleForm.orderNum,
            bizState: self.ruleForm.bizState,
            menuGuids: [...new Set([...menuGuids])],
            tenantGuid: self.page.tenantGuid,
          };
          console.log('33', promise.menuGuids);
          self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/add`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.menuGuidList = [];
              self.$message.success('新增角色成功');
              self.fullscreenLoading = false;
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
              self.fullscreenLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    getNodeByGuid(guid, tree) {
      let node;
      tree.forEach((k) => {
        if (k.guid === guid) {
          node = k;
        } else if (k.children) {
          k.children.forEach((j) => {
            if (j.guid === guid) {
              node = j;
            } else if (j.children) {
              j.children.forEach(m=>{
                 if (m.guid === guid) {
                  node = m;
                }
              })
            }
          });
        }
      });
      return node;
    },
    getNodeByGuid2(guid, tree) {
      this.node;
      tree.forEach((k) => {
        if (k.guid === guid) {
          this.node = k;
        } else if(k.children) {
          this.node = this.getNodeByGuid2(guid, k.children)
        }
      });
      return this.node;
    },
    upDateForm(formName) {
      let self = this;
      console.log('object11111', self.productList);
      self.$refs[formName].validate((valid) => {
        if (valid) {
          const menuGuids = self.productList
            .reduce((total, next) => {
              const arr = (next.checkedKeys || [])
                .map((guid) => {
                  const node = self.getNodeByGuid(guid, next.menus) || {};
                  return node.parentGuid ? node.parentGuid + '-' + node.guid : node.guid;
                })
                .join('-')
                .split('-');
              return [...total, ...arr];
            }, [])
            .filter((k) => k);
          let promise = {
            guid: self.ruleForm.guid,
            platformGuid: self.platformGuid,
            appSideGuid: self.appSideGuid,
            roleName: self.ruleForm.roleName,
            orderNum: self.ruleForm.orderNum,
            bizState: self.ruleForm.bizState,
            menuGuids: [...new Set([...menuGuids])],
            tenantGuid: self.page.tenantGuid,
          };
          //
          console.log('221',promise.menuGuids);
          self.api.put(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/update`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.menuGuidList = [];
              self.$message.success('编辑角色成功');
              self.fullscreenLoading = false;
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
              self.fullscreenLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getReportToken(){
      let self = this;
      let loginInfo = {
        username: 'ExternalAccount',
        // pwd: 'd70413d70ad4af480fa4c6952ab8edb3',//正式
        pwd: '21232f297a57a5a743894a0e4a801fc3',//测试
        timestamp: new Date().getTime()
      }
      let loginUrl = route1 +`/${serverConfig.msReportConfigService}`+ '/user/login?'+`logonUser=`+loginInfo.username+`&pwd=`+loginInfo.pwd;
      let item = {
        appSystemLabel: "FBT",
        pageIndex:self.page.pageIndex,
        pageSize:-1
      }
      fetch(loginUrl, {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            "Authorization": self.$store.state.token,
        },
        body:JSON.stringify(item)
      }
      )
      .then(function (res) { return res.json(); }) .then(function (res) {
        console.log('登录成功',res);
        self.reportToken = res.data.token;
        self.curUserPltTenantGuid = res.data.curUserPltTenantGuid;

      })
    },
    encrypt(txt) {
      let encryptor = new JSEncrypt()
      let publicKey = '-----BEGIN PUBLIC KEY-----MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgFiv3Ko6rOBvWDK96tIExpdyuuQAGgZo0YmQxpT10hD3qu/MnNKlIJgo4+NwUHcwpleKE2DBOxgvCeMtUoP4FDWt8q18X+4+7t8p0D/57NhA0liNKQ/Ise6b5i293ht1XPen3XhR5xIcDNxauQ5vKqdwwzhoonsbJDtbowoinLQbAgMBAAE=-----END PUBLIC KEY-----';
      encryptor.setPublicKey(publicKey) // 设置公钥
      return encryptor.encrypt(txt); // 对数据进行加密
    },
  },
};
</script>
<style  scoped>
.el-tree {
  max-height: 400px;
  overflow-y: scroll;
}
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.remark-class {
  color: #b7b7b7;
}
.mb16 {
  margin-bottom: 16px;
}
.check-txt {
  display: inline-block;
  width: 72px;
  line-height: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.txt-color-grey{
  color: #b7b7b7;
  cursor: auto;
}
.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.ipt-sty {
  flex: 1;
}
.search-area-div {
  width: 72px;
  text-align: right;
}
.button-area {
  padding-left: 16px;
  padding-top: 12px;
}
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
</style>
